<!-- <app-breadcrumb [title]="'Dashboard'"></app-breadcrumb>
<div *ngIf="statistic">
    <div class="row p-5">
        <div class="col-3">
            <div class=" p-3">
                <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&isTotalEmployee=true"
                    class="h6  card-title text-dark mb-0">Transfer Employee</a>
                <p class="h3 mb-0">{{statistic.total | number}}</p>
            </div>
        </div>
        <div class="col-3">
            <div class=" p-3">
                <a href="/management/employees/transfer-requests?page=1&pageSize=10&sort=Id&sortOrder=1&isApproved=true"
                    class="h6  card-title text-dark mb-0">Transfer Request Approved</a>
                <p class="h3 mb-0">{{statistic.approved| number }}</p>
            </div>
        </div>
        <div class="col-3">
            <div class=" p-3">
                <a href="/management/allotment?page=1&pageSize=10&sort=MeritNo&sortOrder=1&isTotalTrasfer=true"
                    class="h6  card-title text-dark mb-0">Total Transfer</a>
                <p class="h3 mb-0">{{statistic.totalTrasfer| number }}</p>
            </div>
        </div>
        <div class="col-3">
            <div class=" p-3">
                <a href="/management/allotment?page=1&pageSize=10&sort=MeritNo&sortOrder=1&isDisplaced=true"
                    class="h6  card-title text-dark mb-0">Total Displased</a>
                <p class="h3 mb-0">{{statistic.displased | number}}</p>
            </div>
        </div>
    </div>
    <div class="row p-5">
        <div class="col-3">
            <div class=" p-3">
                <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&isSingleWomen=true"
                    class="h6  card-title text-dark mb-0">Total Single Woman</a>
                <p class="h3 mb-0">{{statistic.singleWoman | number}}</p>
            </div>
        </div>
        <div class="col-3">
            <div class=" p-3">
                <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&isSpouseIn=true"
                    class="h6  card-title text-dark mb-0">Total Spouse In JNVS</a>
                <p class="h3 mb-0">{{statistic.spouseIn| number }}</p>
            </div>
        </div>
        <div class="col-3">
            <div class=" p-3">
                <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&male=1"
                    class="h6  card-title text-dark mb-0">Total Male</a>
                <p class="h3 mb-0">{{statistic.totalMale| number }}</p>
            </div>
        </div>
        <div class="col-3">
            <div class=" p-3">
                <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&female=2"
                    class="h6  card-title text-dark mb-0">Total Female</a>
                <p class="h3 mb-0">{{statistic.totalFemail | number}}</p>
            </div>
        </div>
    </div>
</div> -->

<app-loader [show]="loading"></app-loader>
<app-breadcrumb [title]="'Dashboard'"></app-breadcrumb>
<div *ngIf="statistic">
    <div class="row mb-3">
        <div class="col-2 d-flex">
            <label class="form-label mt-2">YEAR</label>
            <select id="financialYearId" class="form-select mb-2 ml-3" [(ngModel)]="selectedYear"
                (change)="onYearChange($event.target.value)" #financialYearId="ngModel">
                <option value="0">--ALL Year--</option>
                <option *ngFor="let item of financialYears" [value]="item.value">{{ item.text }}</option>
            </select>

        </div>
        <div class="col-2 d-flex">
            <label class="form-label mt-2">Round</label>
            <select class="form-select mb-2 ml-3" [(ngModel)]="selectedPhase" (change)="onPhaseChange($event)">
                <option value="0">--ALL Phase--</option>
                <option value="1">Phase-I</option>
                <option value="2">Phase-II</option>
            </select>
        </div>

    </div>




    <div class="row d-flex">
        <div class="form-group mb-3">
            <div class="d-flex flex-wrap justify-content-between">
                <!-- Static radio option for Total -->
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="region" id="regionTotal" value="Total"
                        [checked]="selectedRegion === 'Total'" (change)="onRegionChange($event)">
                    <label class="form-check-label" for="regionTotal">
                        Total
                    </label>
                </div>

                <!-- Dynamic radio options -->
                <div *ngFor="let item of regions" class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="region" id="region{{item.value}}"
                        [value]="item.value" [checked]="selectedRegion === item.value"
                        (change)="onRegionChange($event)">
                    <label class="form-check-label" for="region{{item.value}}">
                        {{ item.text }}
                    </label>
                </div>
            </div>
        </div>
    </div>

    <div class="row p-5">
        <div class=" p-3 w-100">
            <h5 class="text-start fw-bold">Employee's Count</h5>
            <div class="row mt-3">
                <div class="col-md-3">
                    <div class="p-3" style="background-color: #e7f1fd !important;">
                        <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&isTotalEmployee=true"
                            class="h6  card-title text-dark mb-0">Registered</a>
                        <p class="h3 mb-0">{{statistic.total | number}}</p>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="p-3" style="background-color: #eceefb !important;">
                        <a href="/management/employees/transfer-requests?page=1&pageSize=10&designationId=&stateId=&districtId=&schoolId=&shalaId=&financialYearId={{setting?.financialYearId}}&phaseId=&isApproved=&isROApproved=approved&isPrincipalApproved=All&isTransfer=true&regionId="
                            class="h6  card-title text-dark mb-0"> Transfer Request Approved</a>
                        <p class="h3 mb-0">{{statistic.approved | number }}</p>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="p-3" style="background-color: #eceefb !important;">
                        <a href="/management/employees?page=1&pageSize=10&designationId=&stateId=&districtId=&schoolId=&shalaId=&male=&female=&isDisplaced=&isSingleWomen=&isSpouseIn=&isTotalEmployee=&financialYearId={{setting?.financialYearId}}&isROApproved=approved&isPrincipalApproved=All&regionId="
                            class="h6  card-title text-dark mb-0">Profile Approved</a>
                        <p class="h3 mb-0">{{statistic.profileApproved | number }}</p>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="p-3" style="background-color: #e7f1fd !important;">
                        <a href="/management/employees/transfer-requests?page=1&pageSize=10&designationId=&stateId=&districtId=&schoolId=&shalaId=&financialYearId={{setting?.financialYearId}}&phaseId=&isApproved=&isROApproved=pending&isPrincipalApproved=All&isTransfer=true&regionId="
                            class="h6  card-title text-dark mb-0">Transfer Request Pending</a>
                        <p class="h3 mb-0">{{statistic.pending | number}}</p>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-3">
                        <div class="p-3" style="background-color: #e7f1fd !important;">
                            <a href="/management/employees?page=1&pageSize=10&designationId=&stateId=&districtId=&schoolId=&shalaId=&male=&female=&isDisplaced=&isSingleWomen=&isSpouseIn=&isTotalEmployee=&financialYearId={{setting?.financialYearId}}&isROApproved=pending&isPrincipalApproved=All&regionId="
                                class="h6  card-title text-dark mb-0">Profile Pending</a>
                            <p class="h3 mb-0">{{statistic.profilePending | number}}</p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="p-3" style="background-color: #eceefb !important;">
                            <a href="/management/employees/transfer-requests?page=1&pageSize=10&designationId=&stateId=&districtId=&schoolId=&shalaId=&financialYearId={{setting?.financialYearId}}&phaseId=&isApproved=&isROApproved=rejected&isPrincipalApproved=All&isTransfer=true&regionId="
                                class="h6  card-title text-dark mb-0">Transfer Request Rejected</a>
                            <p class="h3 mb-0">{{statistic.rejected | number}}</p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="p-3" style="background-color: #eceefb !important;">
                            <a href="/management/employees?page=1&pageSize=10&designationId=&stateId=&districtId=&schoolId=&shalaId=&male=&female=&isDisplaced=&isSingleWomen=&isSpouseIn=&isTotalEmployee=&financialYearId={{setting?.financialYearId}}&isROApproved=rejected&isPrincipalApproved=All&regionId="
                                class="h6  card-title text-dark mb-0">Profile Rejected</a>
                            <p class="h3 mb-0">{{statistic.profileRejected | number}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-3">
                    <div class="p-3" style="background-color: #fefbe8 !important;">
                        <a href="/management/employees/transfer-requests?page=86&pageSize=10&designationId=&stateId=&districtId=&schoolId=&shalaId=&financialYearId={{setting?.financialYearId}}&phaseId=&isApproved=&isROApproved=&isPrincipalApproved=All&isTransfer=true&regionId=&isHardstation=true"
                            class="h6  card-title text-dark mb-0">Opted</a>
                        <p class="h3 mb-0">{{statistic.opted | number}}</p>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="p-3" style="background-color: #e7fdf0 !important;">
                        <a href="/management/allotment?page=1&pageSize=10&sort=MeritNo&sortOrder=1&isTotalTrasfer=true"
                            class="h6  card-title text-dark mb-0">Transferred</a>
                        <p class="h3 mb-0">{{statistic.totalTrasferred | number }}</p>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="p-3" style="background-color: #fafde8 !important;">
                        <a href="/management/allotment?page=1&pageSize=10&sort=MeritNo&sortOrder=1&isDisplaced=true"
                            class="h6  card-title text-dark mb-0">Displaced</a>
                        <p class="h3 mb-0">{{statistic.displased | number}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row p-5">
        <div class="col-md-6 col-lg-3">
            <div class=" p-3 h-100">
                <h5 class="text-start fw-bold">Gender Wise Count</h5>
                <div class="row mt-3">
                    <div class="col-6">
                        <div class="p-3" style="background-color: #e7f1fd !important;">
                            <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&male=1"
                                class="h6  card-title text-dark mb-0">Total Male</a>
                            <p class="h3 mb-0">{{statistic.totalMale | number}}</p>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="p-3" style="background-color: #fdf2fa !important;">
                            <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&female=2"
                                class="h6  card-title text-dark mb-0">Total Female</a>
                            <p class="h3 mb-0">{{statistic.totalFemail | number}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12 col-lg-9">
            <div class=" p-3 h-100">
                <h5 class="text-start fw-bold">Social Category Wise Count</h5>
                <div class="row mt-3">
                    <div class="col-md-3">
                        <div class="p-3" style="background-color: #fdf6ee !important;">
                            <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&CategoryId=1"
                                class="h6  card-title text-dark mb-0">General</a>
                            <p class="h3 mb-0">{{statistic.totalGeneral | number}}</p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="p-3" style="background-color: #e7fdf0 !important;">
                            <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&CategoryId=2"
                                class="h6  card-title text-dark mb-0">OBC</a>
                            <p class="h3 mb-0">{{statistic.totalOBC | number}}</p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="p-3" style="background-color: #fdf6ee !important;">
                            <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&CategoryId=3"
                                class="h6  card-title text-dark mb-0">SC</a>
                            <p class="h3 mb-0">{{statistic.totalSC | number}}</p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="p-3" style="background-color: #e7fdf0 !important;">
                            <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&CategoryId=4"
                                class="h6  card-title text-dark mb-0">ST</a>
                            <p class="h3 mb-0">{{statistic.totalST | number}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row p-5">
        <div class=" p-3 w-100">
            <h5 class="text-start fw-bold">Recruitment Category Wise Count</h5>
            <div class="row mt-3">
                <div class="col-md-3">
                    <div class="p-3" style="background-color: #e7f1fd !important;">
                        <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&RecruitmentCategoryId=5"
                            class="h6  card-title text-dark mb-0">UR</a>
                        <p class="h3 mb-0">{{statistic.totalUR | number}}</p>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="p-3" style="background-color: #fdf2fa !important;">
                        <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&RecruitmentCategoryId=6"
                            class="h6  card-title text-dark mb-0">OBC</a>
                        <p class="h3 mb-0">{{statistic.totalRecruitmentOBC | number}}</p>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="p-3" style="background-color: #eceefb !important;">
                        <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&RecruitmentCategoryId=7"
                            class="h6  card-title text-dark mb-0">SC</a>
                        <p class="h3 mb-0">{{statistic.totalRecruitmentSC | number}}</p>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="p-3" style="background-color: #e7f1fd !important;">
                        <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&RecruitmentCategoryId=8"
                            class="h6  card-title text-dark mb-0">ST</a>
                        <p class="h3 mb-0">{{statistic.totalRecruitmentST | number}}</p>
                    </div>
                </div>

            </div>
            <div class="row mt-3">
                <div class="col-md-3">
                    <div class="p-3" style="background-color: #e7fdfa !important;">
                        <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&RecruitmentCategoryId=10"
                            class="h6  card-title text-dark mb-0">PH(Self)</a>
                        <p class="h3 mb-0">{{statistic.totalPH | number}}</p>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="p-3" style="background-color: #fdf6ee !important;">
                        <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&RecruitmentCategoryId=11"
                            class="h6  card-title text-dark mb-0">Ex-Service Man</a>
                        <p class="h3 mb-0">{{statistic.totalESM | number}}</p>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="p-3" style="background-color: #e6fded !important;">
                        <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&RecruitmentCategoryId=9"
                            class="h6  card-title text-dark mb-0">EWS</a>
                        <p class="h3 mb-0">{{statistic.totalSEWS | number}}</p>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="p-3" style="background-color: #e7f1fd !important;">
                        <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&RecruitmentCategoryId=12"
                            class="h6  card-title text-dark mb-0">Compassionate</a>
                        <p class="h3 mb-0">{{statistic.totalCompassionate | number}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row p-5">
        <div class=" p-3 w-100">
            <h5 class="text-start fw-bold">Priority Category Wise Count</h5>
            <div class="row mt-3">
                <div class="col-md-3">
                    <div class="p-3" style="background-color: #e7f1fd !important;">
                        <a
                            class="h6  card-title text-dark mb-0">PH(Self)</a>
                        <p class="h3 mb-0">{{statistic.priorityPHSelf | number}}</p>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="p-3" style="background-color: #eceefb !important;">
                        <a
                            class="h6  card-title text-dark mb-0">PH(Other)</a>
                        <p class="h3 mb-0">{{statistic.priorityPHOther | number}}</p>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="p-3" style="background-color: #e7f1fd !important;">
                        <a 
                            class="h6  card-title text-dark mb-0">Med(Self)</a>
                        <p class="h3 mb-0">{{statistic.priorityMedSelf | number}}</p>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="p-3" style="background-color: #eceefb !important;">
                        <a 
                            class="h6  card-title text-dark mb-0">Med(Other)</a>
                        <p class="h3 mb-0">{{statistic.priorityMedOther | number}}</p>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-3">
                        <div class="p-3" style="background-color: #fefbe8 !important;">
                            <a 
                                class="h6  card-title text-dark mb-0">Single Lady</a>
                            <p class="h3 mb-0">{{statistic.singleWoman | number}}</p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="p-3" style="background-color: #e7fdf0 !important;">
                            <a 
                                class="h6  card-title text-dark mb-0">NVS Spouse</a>
                            <p class="h3 mb-0">{{statistic.spouseIn| number }}</p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="p-3" style="background-color: #fefbe8 !important;">
                            <a 
                                class="h6  card-title text-dark mb-0">C/S Spouse</a>
                            <p class="h3 mb-0">{{statistic.priorityChoiceSpouse | number}}</p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="p-3" style="background-color: #e7fdf0 !important;">
                            <a 
                                class="h6  card-title text-dark mb-0">DFR</a>
                            <p class="h3 mb-0">{{statistic.priorityDFR | number}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row p-5">
            <div class=" p-3 w-100">
                <h5 class="text-start fw-bold">Religion Wise Count</h5>
                <div class="row mt-3">
                    <div class="col-md-3">
                        <div class="p-3" style="background-color: #e7f1fd !important;">
                            <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&ReligionId=1"
                                class="h6  card-title text-dark mb-0">Hinduism</a>
                            <p class="h3 mb-0">{{statistic.totalSHinduism | number}}</p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="p-3" style="background-color: #fdf2fa !important;">
                            <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&ReligionId=2"
                                class="h6  card-title text-dark mb-0">Islam</a>
                            <p class="h3 mb-0">{{statistic.totalSIslam | number}}</p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="p-3" style="background-color: #e7f1fd !important;">
                            <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&ReligionId=4"
                                class="h6  card-title text-dark mb-0">Sikhism</a>
                            <p class="h3 mb-0">{{statistic.totalSSkhism | number}}</p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="p-3" style="background-color: #fdf2fa !important;">
                            <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&ReligionId=5"
                                class="h6  card-title text-dark mb-0">Buddhism</a>
                            <p class="h3 mb-0">{{statistic.totalSBuddhism | number}}</p>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-3">
                        <div class="p-3" style="background-color: #e7f1fd !important;">
                            <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&ReligionId=6"
                                class="h6  card-title text-dark mb-0">Jainism</a>
                            <p class="h3 mb-0">{{statistic.totalSJainism | number}}</p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="p-3" style="background-color: #fdf6ee !important;">
                            <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&ReligionId=3"
                                class="h6  card-title text-dark mb-0">Christianity</a>
                            <p class="h3 mb-0">{{statistic.totalSChristian | number}}</p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="p-3" style="background-color: #e7fdfa !important;">
                            <a href="/management/employees?page=1&pageSize=10&sort=UserId&sortOrder=1&ReligionId=99"
                                class="h6  card-title text-dark mb-0">Other</a>
                            <p class="h3 mb-0">{{statistic.totalSOther | number}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>